var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4625 50.875V57.35",
    stroke: "#FF9900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0458 67.8333H52.8792V64.75C52.8792 61.3583 50.1042 58.5833 46.7125 58.5833H28.2125C24.8208 58.5833 22.0458 61.3583 22.0458 64.75V67.8333V67.8333Z",
    stroke: "#FF9900",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9625 67.8333H55.9625",
    stroke: "#FF9900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2392 46.4659C19.7642 42.735 15.4167 35.7667 15.4167 27.75V18.5C15.4167 11.6859 20.9358 6.16669 27.75 6.16669H46.25C53.0642 6.16669 58.5833 11.6859 58.5833 18.5V27.75C58.5833 39.5284 49.1792 49.0867 37.4625 49.3334C37.3083 49.3334 37 49.3334 37 49.3334",
    stroke: "#FF9900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8658 35.9208C14.5533 35.1808 12.5183 33.8241 10.915 32.2208C8.14001 29.1375 6.29001 25.4375 6.29001 21.1208C6.29001 16.8041 9.68168 13.4125 13.9983 13.4125H16.0025C15.3858 14.8308 15.0775 16.4033 15.0775 18.0375V27.2875C15.0775 30.3708 15.725 33.2691 16.8658 35.9208Z",
    stroke: "#FF9900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1342 35.9208C59.4467 35.1808 61.4817 33.8241 63.085 32.2208C65.86 29.1375 67.71 25.4375 67.71 21.1208C67.71 16.8041 64.3183 13.4125 60.0017 13.4125H57.9975C58.6142 14.8308 58.9225 16.4033 58.9225 18.0375V27.2875C58.9225 30.3708 58.275 33.2691 57.1342 35.9208Z",
    stroke: "#FF9900",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.3dd3c2053b4a776efcaac377992d058f.svg";
export { ForwardRef as ReactComponent };